import React, { useState, MouseEvent } from 'react'
import Typed from '../Typed'
import QuestionState from '../../types/QuestionState'
import ViewProps from '../../types/ViewProps'
import Answer from '../../types/Answer'

const MultiSelectModal = ({ choices, currentChoices, onChoice, closeModal }: { choices: Array<Answer>, currentChoices: Array<Answer>, onChoice: (answer: string) => void, closeModal: (event: MouseEvent<HTMLDivElement>) => void }) => {
    const [hover, setHover] = useState<{
        x: number,
        y: number,
        width: number,
        height: number,
        done: boolean,
    }>({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        done: false,
    })

    return (
        <div className={"modal-wrap"}>
            <div className={"modal modal-multiselect"}>
                <div className={"choices"}
                    onMouseLeave={() => {
                        if (!hover.done) {
                            setHover({ ...hover, height: 0 })
                        }
                    }}
                >
                    <p className={"select"}>Select all that apply</p>
                    <div className={'hover' + (hover.done ? ' done' : '')} style={{ transform: `translate(${hover.x}px, ${hover.y}px)`, width: `${hover.width}px`, height: `${hover.height}px` }} />
                    {choices.map(q => (
                        <div
                            className={`choice ${typeof currentChoices.find(c => c.name === q.text) !== "undefined" ? ' chosen' : ''}`}
                            key={q.text}
                            onMouseEnter={(e) => {
                                if (!hover.done) {
                                    const target = e.target as HTMLElement
                                    setHover({
                                        x: target.offsetLeft,
                                        y: target.offsetTop,
                                        width: target.offsetWidth,
                                        height: target.offsetHeight,
                                        done: false,
                                    })
                                }
                            }}
                            onClick={() => {
                                setTimeout(() => {
                                    onChoice(q.text)
                                }, 100)
                            }}
                        >{q.text}</div>
                    ))}
                </div>
            </div>
            <div className={"done"} onClick={closeModal}>Done</div>
        </div>
    )
}

export default ({ data, path, handleClick, appState, setAppState }: ViewProps) => {
    const q = data!.find(q => q.id === path)
    const answers = appState[path!] as Array<Answer>

    const [questionState, setQuestionState] = useState<QuestionState>({
        showModal: false,
        complete: false
    })

    const handleChoice = (answer: string) => {
        const choice = q!.answers.find(a => a.text === answer)
        const match = (appState[path!] as Array<Answer>).find(c => c.name === choice!.text)

        let nextState = {}

        if ((appState[path!] as Array<Answer>).length === 0 || typeof match === 'undefined') {
            if (choice!.text === 'None of these') {
                nextState = { ...appState, [path!]: [ { name: choice!.text, page: choice!.page } ], next: choice!.target }
            }
            else {
                const choices = (appState[path!] as Array<Answer>).filter(c => c.name !== 'None of these')
                nextState = { ...appState, [path!]: [ ...choices, { name: choice!.text, page: choice!.page }], next: choice!.target }
            }
        }
        else if ((appState[path!] as Array<Answer>).length > 0 && typeof match !== 'undefined') {
            // remove match
            const choices = answers!.filter(a => a.name !== choice!.text)
            nextState = { ...appState, [path!]: choices }
        }

        setQuestionState({ ...questionState, complete: true })
        setAppState(nextState)
    }

    const handleModal = (event: MouseEvent<HTMLDivElement>) => {
        setQuestionState({ ...questionState, showModal: true })
    }

    const closeModal = (event: MouseEvent<HTMLDivElement>) => {
        setQuestionState({ ...questionState, showModal: false })
        event.stopPropagation()
    }

    const refresh = (event: MouseEvent): void => {
        setQuestionState({ complete: false })
        handleClick!(event)
    }

    const answer = answers.length > 0 ? answers[0].name : ''
    const showNext = answers.length > 0 && !questionState.showModal ? ' show' : ''
    const question = questionState.complete ? q!.question : <Typed>{q!.question}</Typed>

    return (
        <div>
            <div className="question" onClick={handleModal}>
                {!questionState.showModal && (
                    <div>
                        {q!.questionCategory !== '' &&  (
                            <h3 className={`category ${questionState.complete ? '' : 'animate'}`} style={{ animationDelay: '400ms'}}>{q!.questionCategory}</h3>
                        )}
                        <h1>{question}</h1>
                        <div className={`answer ${questionState.complete ? '' : 'animate'}`} style={{ animationDelay: `${q?.answerDelay}ms`}}>
                            {(appState[path!] as Array<Answer>).length === 0 ? '' : answer}
                        </div>
                        {!questionState.showModal && answers.length > 1 && answers.slice(1).map(a => {
                            return (
                                <div className={`answer ${questionState.complete ? '' : 'animate'}`} key={a.name} style={{ animationDelay: `${q?.answerDelay}ms`}}>
                                    {a.name}
                                </div>
                            )
                        })}
                    </div>
                )}
                {questionState.showModal && (
                    <MultiSelectModal choices={q!.answers} currentChoices={answers} onChoice={handleChoice} closeModal={closeModal} />
                )}
            </div>
            <div onClick={(e) => refresh(e)} className={`nav-link nav-link--landing${showNext}`}>Next</div>
        </div>
    )
}
